const styles = (theme) => ({
    headCell: {
        color: theme.palette.common.white,
    },
    tableCell: {
        fontSize: '12px',
    },
    filterPanel: {
        marginTop: '10px',
        alignItems: 'center',
    },
    searchField: {
        marginTop: '11px',
    },
    filterButton: {
        marginTop: '22px',
        float: 'right',
    },
    btnDescription: {
        cursor: 'pointer',
    },
    obs: {
        fontSize: '11px',
        color: '#611a15',
    },
    search: {
        borderRadius: '40px',
        overflow: 'hidden',
        height: '47px',
    },
    alignRight: {
        textAlign: 'right',
    },
    dates: {
        marginTop: '0',
    },
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
